import React, { createContext, useContext } from "react";

const SessionContext = createContext();

export const useSession = () => useContext(SessionContext);

export const SessionProvider = ({ children, value }) => {
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
};